// 학생 v2 메뉴는 임시로 숨긴다. true로 바꾸면 기존 권한에 따라 다시 표시한다.
// 화면 접근 권한과 운영 전환 설정은 roles.js를 따른다.
export const SHOW_ACADEMY_MENU = false;

// v1 문제 메뉴 셋(문제생성 · 문제관리 · 수동출력)은 사이드바와 모바일에서 함께 숨긴다.
// true로 바꾸면 두 메뉴에 다시 표시한다. 기존 주소와 기능은 유지한다.
export const SHOW_V1_PROBLEM_MENUS = false;
